import { getAxiosInstance } from "../ApiConfig";

async function FetchAllCampaignByCompany() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCampaignByCompany`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllCampaignByCreatedBy(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCampaignByCreatedBy${page ? `?page=${page}&limit=${limit}` : ''}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllCampaignPaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCampaignByCreatedBy?page=${page}&limit=${limit}&search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllCampaignSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCampaignByCreatedBy?search=${search}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchCampaignType() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCampaignType`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchCampaignStatus() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCampaignStatus`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function CampaignSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createCampaign`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function CampaignUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCampaign/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function TriggerCampaignMails(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/triggerCampaignMails/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function CampaignDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findOnebyCampaignId/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function GetCampaignSendStatus(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getCampaignSendStatus/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findAllCampaignByMonthAndYear(month, year) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllCampaignByMonthAndYear/${month}/${year}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function CampaignDelete(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteCampaign/${id}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getCampaignSendReport(campaignId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getCampaignSendReport/${campaignId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}

export {
    getCampaignSendReport,
    findAllCampaignByMonthAndYear,
    GetCampaignSendStatus,
    TriggerCampaignMails,
    FetchAllCampaignByCompany,
    FetchAllCampaignByCreatedBy,
    FetchCampaignType,
    FetchCampaignStatus,
    CampaignSave,
    CampaignUpdate,
    CampaignDetails,
    CampaignDelete,
    AllCampaignPaginationSearch,
    AllCampaignSearch
}